import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4EBC73",
      d: "M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0m0 16.65A7.65 7.65 0 1 1 16.65 9 7.66 7.66 0 0 1 9 16.65"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4EBC73",
      d: "m11.277 6.779-2.7 2.7-1.098-1.116a.675.675 0 0 0-.954.954L8.109 10.9a.675.675 0 0 0 .954 0l3.168-3.168a.675.675 0 0 0-.954-.954"
    }, null, -1)
  ])))
}
export default { render: render }